angular.module('impactx.toolbar').controller('MainToolbarCtrl', [
    'ToolbarService',
    'sidebarShow',
    'TranslationService',
    'ListFilterService',
    MainToolbarController
]);

function MainToolbarController(ToolbarService, sidebarShow, TranslationService, ListFilterService) {
    var self = this;
    self.isToolbarHidden = ToolbarService.isToolbarHidden;

    self.isOpen = function () {
        return sidebarShow.isOpen();
    };

    self.showDialogFilterToggle = ToolbarService.showDialogFilter;
    self.toggleDialogSidebar = ToolbarService.toggleDialogSidebar;
    self.translationService = TranslationService;

    self.toolbarService = ToolbarService;
    self.listFilterService = ListFilterService;
}